import { useEffect, useState } from 'react';
import { THEMES, applyTheme, readStoredTheme, storeTheme } from '../lib/branding';
import type { Theme } from '../lib/branding';
import { EnumSelect } from './ui/select';
import { Label } from './ui/input';

const THEME_LABELS: Record<Theme, string> = {
  light: 'Jasny',
  dark: 'Ciemny',
  system: 'Systemowy',
};

/** Przelacznik motywu. `system` slucha zmiany preferencji w trakcie sesji. */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => readStoredTheme());

  useEffect(() => {
    applyTheme(theme);
    if (theme !== 'system' || typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const listener = (): void => {
      applyTheme('system');
    };
    media.addEventListener('change', listener);
    return () => {
      media.removeEventListener('change', listener);
    };
  }, [theme]);

  return (
    <div className="flex items-center gap-2">
      <Label htmlFor="theme-select" className="sr-only">
        Motyw
      </Label>
      <EnumSelect
        id="theme-select"
        value={theme}
        options={THEMES}
        labelOf={(value) => THEME_LABELS[value]}
        onChange={(value) => {
          setTheme(value);
          storeTheme(value);
        }}
        className="h-8 w-32 text-xs"
      />
    </div>
  );
}
